//import { useAuth } from "../context/AuthContext";
import landingPageImg from "../landingpage.jpg";
import logo from "../logo.png";
export default function Home() {
  
   return (
    <div className="relative h-screen w-full flex items-center justify-center bg-black overflow-hidden font-sans">
      
      {/* 1. Full-Bleed Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src={landingPageImg} 
          alt="Restaurant interior background" 
          className="w-full h-full object-cover transform scale-105 animate-pulse-slow"
        />
        {/* Dark overlay tint for high contrast text readability */}
        <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]"></div>
      </div>

      {/* 2. Central Content Card */}
      <div className="relative z-10 text-center text-white px-6 max-w-2xl mx-auto space-y-6">
        
        {/* Logo / Brand Name */}
        <img src={logo} alt="The Atithi Dhaba Logo" className="w-24 h-auto mx-auto mb-4" style={{ borderRadius: '50%', width:'160px' }} />
        <span className="text-xs uppercase tracking-[0.3em] text-amber-400 font-semibold block mb-2">
          Tradition Goes Digital
        </span>
        
        {/* Main Header */}
        <h1 className="text-4xl sm:text-6xl font-serif font-bold tracking-tight leading-none">
          Welcome to <br />
          <span className="text-amber-500 font-light italic font-serif">The Atithi Dhaba</span>
        </h1>
        
        {/* Coming Soon Badge */}
        <div className="inline-block border border-white/20 bg-white/5 px-6 py-2 rounded-full backdrop-blur-sm my-4">
          <p className="text-xs uppercase tracking-[0.2em] font-medium text-gray-200">
            ✨ 🔥 The Tandoors Are Heating Up...
          </p>
        </div>

        {/* Short Subtext Description */}
        <p className="text-sm sm:text-base text-gray-300 leading-relaxed max-w-md mx-auto font-light">
          <strong>We are putting the final touches on our digital home. Soon, you will be able to browse our full menu, reserve your table, and order your favorite tandoori specialties </strong>
        </p>

        {/* Simple Divider Line */}
        <div className="w-12 h-[1px] bg-amber-500/50 mx-auto my-6"></div>

        {/* Footer / Location Whisper */}
        <p className="text-[11px] uppercase tracking-widest text-gray-400">
          Opening Mid-Summer • Indore, MP
        </p>

      </div>
    </div>
  );
}
